import { LayoutLegal } from "../components/shared/LayoutLegal";

export const Cookies = () => {
  return (
    <LayoutLegal>
      <h1>Política de Cookies</h1>

      <h2>¿Qué son las cookies?</h2>
      <p>
        Las cookies son pequeños archivos de texto que se almacenan en tu
        navegador cuando visitas sitios web. Sirven para recordar información
        sobre tu visita, como el idioma preferido o tus datos de inicio de
        sesión, y para mejorar tu experiencia como usuario.
      </p>

      <h2>¿Qué tipos de cookies utilizamos?</h2>
      <ul>
        <li>
          <strong>Cookies técnicas:</strong> Son necesarias para el
          funcionamiento básico del sitio y no requieren consentimiento.
        </li>
        <li>
          <strong>Cookies de personalización:</strong> Permiten recordar tus
          preferencias (como el idioma o región).
        </li>
        <li>
          <strong>Cookies de análisis:</strong> Nos ayudan a entender cómo
          interactúan los usuarios con el sitio web (por ejemplo, mediante
          Google Analytics).
        </li>
        <li>
          <strong>Cookies de publicidad:</strong> Se usan para mostrar anuncios
          personalizados en función de tus hábitos de navegación.
        </li>
      </ul>

      <h2>¿Cómo puedes gestionar las cookies?</h2>
      <p>
        Puedes permitir, bloquear o eliminar las cookies instaladas en tu equipo
        mediante la configuración de tu navegador. A continuación te dejamos
        enlaces con instrucciones para los navegadores más comunes:
      </p>
      <ul>
        <li>
          <a
            href="https://support.google.com/chrome/answer/95647?hl=es"
            target="_blank"
          >
            Google Chrome
          </a>
        </li>
        <li>
          <a
            href="https://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-sitios-web-rastrear-preferencias"
            target="_blank"
          >
            Mozilla Firefox
          </a>
        </li>
        <li>
          <a
            href="https://support.apple.com/es-es/guide/safari/sfri11471/mac"
            target="_blank"
          >
            Safari
          </a>
        </li>
        <li>
          <a
            href="https://support.microsoft.com/es-es/help/17442/windows-internet-explorer-delete-manage-cookies"
            target="_blank"
          >
            Internet Explorer
          </a>
        </li>
      </ul>

      <h2>Cookies de terceros</h2>
      <p>
        Este sitio puede utilizar servicios de terceros que recopilan
        información con fines estadísticos y de publicidad, como:
      </p>
      <ul>
        <li>Google Analytics</li>
        <li>Facebook Pixel</li>
        <li>Hotjar</li>
        <li>LinkedIn Insight Tag</li>
      </ul>

      <h2>Consentimiento</h2>
      <p>
        Al continuar navegando por nuestro sitio web, aceptas el uso de cookies
        en las condiciones establecidas en esta Política de Cookies. Puedes
        retirar tu consentimiento en cualquier momento.
      </p>

      <h2>Modificaciones</h2>
      <p>
        Nos reservamos el derecho de actualizar esta Política de Cookies para
        adaptarla a novedades legislativas o técnicas. Te recomendamos revisarla
        periódicamente.
      </p>

      <p>Última actualización: 26.04.2025</p>
    </LayoutLegal>
  );
};
